var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('nav-bar')],1),_c('el-container',{staticClass:"app-main-box"},[_c('el-aside',{staticClass:"hidden-scrollbar",attrs:{"width":"210px"}},[_c('side-bar'),_c('my-footer')],1),_c('el-container',{staticClass:"hidden-scrollbar"},[_c('el-main',[_c('app-main')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }